import axios from 'axios'

/** The stable `reason` slug from an API error response, if any. */
export const getReason = (error: unknown): string | undefined =>
    axios.isAxiosError(error) ? error.response?.data?.reason : undefined

export const getStatus = (error: unknown): number | undefined =>
    axios.isAxiosError(error) ? error.response?.status : undefined

/** react-query retry policy: retry server errors a couple of times, never 4xx (they won't change). */
export const retryServerErrors = (failureCount: number, error: unknown) => {
    const status = getStatus(error)
    return (status === undefined || status >= 500) && failureCount < 2
}
